'use strict';

//=include  ../../MetricsTracker/booker/metrics.js

import BookerTracker from '../../MetricsTracker/booker/metrics';
import GlobalUtil from '../../utils/pricetravel/shared/globalUtil';
window.app.controller('BookerFlightController', controller);
import { StorageService } from '../../vue/services/StorageService';
controller.$inject = ["$scope", "$http", "$q", "$timeout", "localStorageService", "$location", "$rootScope"];

function controller($scope, $http, $q, $timeout, localStorageService, $location, $rootScope) {
    let vm = this;
    let internal = {};
    let config = window.__pt.settings.site;
    let setting = window.__pt.settings;
    let destinationFlight = window.__pt.dataD || {};
    let lang = window.__pt.ln;
    let fn = window.__pt.fn;
    let defaultDate = fn.getDate()
    let _placeOrigin = window.__pt.placeOrigin || {};
    let _placeDestination = window.__pt.placeDestination || {};
    let maxhistorySize = setting.bookerHistorySize;
    let _list = "";
    let _inputName = "";
    let _datePicker = {}
    let _picker = null;
    let tracker = new BookerTracker();
    let valuesDefaults = {}
    let localeDatePicker = {
        format: setting.formatBoxDate,
        firstDay: 0,
        applyLabel: lang.ok,
        cancelLabel: lang.cancel
    }
    vm.config = config;
    vm.error_paxes = false;
    vm.destinationEquals = false;
    vm.siteUrl = window.__pt.settings.site.siteUrl;
    vm.typeFlightSuggestion = 11;
    vm.submit = false;
    vm.years = [];
    vm.suggestion = {
        from: {
            results: [],
            show: false
        },
        to: {
            results: [],
            show: false
        },
        paxes: false
    };
    vm.hasResult = false;
    vm.algoliaUrl = window.__pt.settings.site.metricsSuffix != 'TB' ? "https://pricetravel.com/assets/recent-search-imgs/iatas/" : "https://www.tiquetesbaratos.com/assets/recent-search-imgs/iatas/";
    vm.validation = {
        paxes: true,
        checkIn: true,
        checkOut: true,
        dates: true
    }
    vm.settingPaxes = {
        minAdults: 1,
        maxAdults: 9,
        minChildren: 0,
        maxChildren: 8,
        minAge: 1,
        maxAge: 11,
        totalPaxes: 9
    };

    vm.data = setting.defaultFlight;
    vm.mode = true;
    vm.placeInputHasFocus = {
        to: false,
        from: false
    };
    vm.history = {
        from: [],
        to: []
    };
    let _globalUtil = new GlobalUtil();
    let _userKey = _globalUtil.getUserKey();
    let origin = null;

    $rootScope.$on(setting.bookerValuesEventFlight, function (event, args) {
        vm.data = args.data;
        vm.data.checkIn = fn.getDate(vm.data.checkIn);
        vm.data.checkOut = fn.getDate(vm.data.checkOut);
        vm.onChangeFlight();

        $timeout(() => vm.onSubmit(vm.form, true), 100)
    });
    vm.onSearch = (value, list, input, focus) => {
        if (value === "" || value === null || value === undefined || value.length < 3) {
            AlgoliaSearch(list);
        }

        if (!value || (value && value.length < 3)) {
            return;
        }
        vm.hasResult = false;

        if (vm.form[input].$valid) {
            _inputName = focus;
            _list = list;
            const params = {
                query: value,
                language: config.language,
                placeTypes: config.placesTypeHotel,
                from: 0,
                size: config.siteName == "tiquetesbaratos" ? 5 : 10,
                usersearch: _userKey,
                site: config.code,
                analyticsTags: getAnalyticsTags()
            }
            $http.get(config.endPoints.suggestionFlightUrl, {
                params: params
            }).then(onSuccessSuggestion, onError)
        }
    }
    vm.onSubmit = (form) => {

        if (this.validAgeChildrenforAdult()) {
            this.showPaxes();
            return;
        }
        vm.submit = true;
        vm.validation.paxes = isValidPax(vm.data.paxes, form);
        vm.validation.checkIn = isValidDate(defaultDate, vm.data.checkIn);
        vm.validation.checkOut = isValidDate(defaultDate, vm.data.checkOut);
        vm.validation.dates = vm.data.mode ? isValidDate(vm.data.checkIn, vm.data.checkOut) : true;
        if (form.$valid && vm.validation.paxes && vm.validation.checkIn && vm.validation.checkOut && vm.validation.dates) {
            if (vm.data.place_selected.code == vm.data.place_selected_to.code) {
                vm.destinationEquals = true;
            } else {
                const airlinePathURL = window.location.pathname.split("/").filter(Boolean);
                const airlineKeywords = ["aerolineas", "airlines"];

                let landing = "";
                const index = airlinePathURL.findIndex(segment => airlineKeywords.includes(segment));

                if (index !== -1 && airlinePathURL[index + 1]) {
                    landing = airlinePathURL[index + 1];
                }
                vm.destinationEquals = false;

                let paxesData = MapPaxToUrl(vm.data.paxes);

                let mode = vm.data.mode ? "1" : "0";

                let data = {
                    startingFromAirport: vm.data.place_selected.code,
                    returningFromAirport: vm.data.place_selected_to.code,
                    startingFromDateTime: fn.formatDate(vm.data.checkIn, setting.formatDate),
                    returningFromDateTime: fn.formatDate(vm.data.checkOut, setting.formatDate),
                    tripMode: mode,
                    mode: mode,
                    originName: vm.data.place_name,
                    destinationName: vm.data.place_name_to
                };
                if (landing != "") {
                    data.addfirst = landing;
                }
                data = { ...data, ...paxesData };

                var path = config.pathFlight;

                tracker.metricBookerFlight('booker', { vmData: vm.data, data });

                var form = document.createElement("form");
                form.setAttribute("method", "get");
                form.setAttribute("action", `${path}`);
                for (var key in data) {
                    if (data[key]) {
                        var hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", key);
                        hiddenField.setAttribute("value", data[key]);

                        form.appendChild(hiddenField);
                    }
                }
                setSearchHistory(vm.data);
                setRecentDestination(vm.data);
                StorageService.set('bookerFlight', vm.data);
                $("#loader-page").removeClass("d-none");
                document.body.appendChild(form);
                form.submit();
            }
        }
    }
    vm.onSelect = (item, type, suffix) => {
        vm.data[`place_name${suffix}`] = `${item.displayText} - ${item.displayDestinationHtml} (${item.code})`;
        vm.data[`place_selected${suffix}`] = item;
        vm.suggestion[type].show = false;
        vm.placeInputHasFocus[type] = false;
        if (type === 'from') {
            origin = item.code;
        }
        analyticsAlgolia(item, item.positions, type);
    }

    vm.showPaxes = () => {
        vm.suggestion.paxes = true;
    }

    vm.addRoom = () => {
        const paxesDefault = fn.clone(setting.defaultPaxes);
        vm.data.paxes.push(paxesDefault);
        updateInputPaxes();
    }

    vm.onFocus = (element, input) => {
        _list = element;
        _inputName = input;
        vm.hasResult = true;
        setTimeout(() => {
            AlgoliaSearch(element);
        }, 200)


        if (vm.suggestion[element]["results"].length) {
            setTimeout(() => {
                $scope.$apply(() => {
                    vm.suggestion[element]["show"] = true;
                    if (fn.mobileAndTabletCheck()) {
                        onFocusElement(`${input}_modal`)
                    }
                });
            }, 250)
        }
    }

    vm.getIcon = (type) => {
        let icon = "icons-world"//
        switch (type) {
            case 6:
                icon = "icons-world";//
                break;
            case 3:
                icon = "icons-location"; //
                break;
            case 11:
                icon = "icons-local-airport";
                break;
            case 7:
                icon = "icons-compass";//
                break;
            case 14:
                icon = "icons-bed";//
                break;
            case 12:
                icon = "icons-monument";//
                break;
        }

        return [icon]
    }


    vm.removePax = (pax, prop, minValue) => {
        if ((pax[prop] - 1) >= minValue) {
            pax[prop] -= 1;
        }
        updateInputPaxes();
        this.validAgeChildrenforAdult();

        if (ValidTotalPaxes(pax, vm.settingPaxes.totalPaxes)) {
            return;
        }
    }

    vm.addPax = (pax, prop, maxValue) => {
        if (ValidTotalPaxes(pax, maxValue)) {
            return;
        }

        if ((pax[prop] + 1) <= maxValue) {
            pax[prop] += 1;
        }
        updateInputPaxes();
        this.validAgeChildrenforAdult();
    }


    vm.removeChildren = (pax, prop, minValue) => {
        if ((pax[prop].length - 1) >= minValue) {
            pax[prop].splice(pax[prop].length - 1, 1);
        }
        updateInputPaxes();

        if (ValidTotalPaxes(pax, vm.settingPaxes.totalPaxes)) {
            return;
        }
    }

    vm.addChildren = (pax, prop, maxValue) => {

        if (ValidTotalPaxes(pax, maxValue)) {
            return;
        }

        if ((pax[prop].length + 1) <= maxValue) {
            pax[prop].push({
                year: null
            });
        }
        updateInputPaxes();

    }

    vm.validAgeChildrenforAdult = () => {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let agekids = [];
        let rooms = vm.data.paxes.length;

        for (let i = 0; i < rooms; i++) {
            const room = vm.data.paxes[i];

            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                kids += 1;
            }

        }
        paxesKeys[`adults`] = adults;
        paxesKeys[`kids`] = kids;
        paxesKeys[`agekids`] = agekids.join(",");


        let totalChildren = 0;
        if (paxesKeys[`adults`] < paxesKeys[`kids`]) {

            agekids.forEach((age, index) => {
                if (age == 1)
                    totalChildren++;
            });

            if (totalChildren > paxesKeys[`adults`]) {
                return true;
            }
            else return false;
        }
        else return false;

    }
    vm.onClose = (obj, prop, type) => {
        if (somePaxHasError()) {
            vm.form.$setSubmitted();
            return;
        }
        obj[prop] = false;
        setValidation(prop);
        vm.placeInputHasFocus[type] = false;
    }

    vm.onRemove = (obj, prop, index) => {
        obj[prop].splice(index, 1);
        updateInputPaxes();
    }


    vm.hasError = (form, property) => {
        let input = form[property];
        return form.$submitted && input.$invalid
    }


    vm.isInvalidInput = (form, inputName, position, inputNumber) => {
        return form.$submitted && form[`${inputName}_${position}_${inputNumber}`].$invalid
    }

    vm.onClickOutside = (element, prop, type) => {
        vm.placeInputHasFocus[type] = false;
        element[prop] = false;
        setValidation(prop);
    }


    vm.onChangeFlight = () => {
        initDatePicker();
    }

    vm.deleteSelection = (input, selection, type, inputFocus) => {
        vm.data[input] = null;
        vm.data[`${selection}${type.length ? '_' + type : ''}`] = {};

        onFocusElement(inputFocus);
    }

    vm.clickInputInMobile = (focus, type) => {
        _inputName = focus;
        vm.placeInputHasFocus[type] = true;
        if (fn.mobileAndTabletCheck()) {
            onFocusElement(`${_inputName}_modal`)
            if (vm.data.place_name && vm.data.place_name.length > 3) {
                setTimeout(() => {
                    const elem = document.getElementById(`${_inputName}_modal`)
                    if (elem) elem.setSelectionRange(0, elem.value.length);
                }, 200);
            }
        }

    }

    internal.setDataArgolia = (item, index, type) => {
        if (item && item.items && item.items.queryID && item.items.objectID && window.aa && item.items.indexName) {
            let indexName = item.items.indexName || config.algoliaSearchFlight;
            let queryid = item.items.queryID;
            let objectid = item.items.objectID;
            let position = index;
            let userToken = _userKey;
            var objectArgolia = {
                objectIDs: objectid,
                queryID: queryid,
                userToken: userToken,
                position: position,
                indexName: indexName
            }
            StorageService.setSession("_key_argo_object_flight_" + type, JSON.stringify(objectArgolia));
            window.aa('clickedObjectIDsAfterSearch', {
                userToken: userToken,
                eventName: 'Buscador Click',
                index: indexName,
                queryID: queryid,
                objectIDs: [objectid],
                positions: [position],
            });
        }
    }

    /***** Private *****/
    function ValidTotalPaxes(pax, maxValue) {
        const cantTotalt = pax['adults'] + pax['children'].length

        if (cantTotalt == vm.settingPaxes.totalPaxes) {
            vm.error_paxes = true;
            return true;
        }

        if (cantTotalt >= vm.settingPaxes.totalPaxes) {
            vm.error_paxes = true;
            return true;
        }
        else {
            vm.error_paxes = false;
            return false;
        }
    }

    function init() {
        initialDefaultDate();
        initSearchBox();
        initDatePicker();
        updateInputPaxes();
        getSearchHistory();

        for (let index = vm.settingPaxes.minAge; index <= vm.settingPaxes.maxAge; index++) {
            vm.years.push({ year: index });
        }
    }

    function onSuccessSuggestion(response) {

        const data = response.data || [];
        vm.suggestion[_list]["results"] = data;
        vm.suggestion[_list]["show"] = true;
        vm.placeInputHasFocus[_list] = true;

        if (fn.mobileAndTabletCheck()) {
            onFocusElement(`${_inputName}_modal`)
        }
    }

    function AlgoliaSearch(element) {
        const params = {
            analyticsTags: getAnalyticsTags(),
            from: 0,
            language: config.language,
            placeTypes: 0,
            site: config.code,
            size: 5,
            usersearch: _userKey,
            recommendation: true,
            origin: !!origin && element === 'to' ? origin : null,
        }
        $http.get(config.endPoints.suggestionFlightUrl, {
            params: params
        }).then(onSuccessSuggestion, onError)
    }

    function onError(response) {
        console.log(response)
    }

    function initSearchBox() {
        let paramsData, storageData;

        if (setting.page != 'home') {
            paramsData = getUserSelectionParams();
        } else {
            storageData = StorageService.get('bookerFlight');
        }

        if (storageData) {
            storageData.place_name = null;
            storageData.place_name_to = null;
            storageData.place_selected = {};
            storageData.place_selected_to = {};
        }
        vm.data = paramsData || storageData || vm.data;
        if (destinationFlight && Object.keys(destinationFlight).length > 0 && destinationFlight.startingAirportPlace.airport !== "" && destinationFlight.returningAirportPlace.airport !== "") {
            vm.data.place_name = destinationFlight.startingAirportPlace?.cityFullName || null;
            vm.data.place_name_to = destinationFlight.returningAirportPlace?.cityFullName || null;

            vm.data.place_selected = destinationFlight.startingAirportPlace ? {
                id: destinationFlight.startingAirportPlace.airportCode,
                displayText: destinationFlight.startingAirportPlace.cityName,
                displayDestinationHtml: destinationFlight.startingAirportPlace.cityFullName,
                displayHtml: destinationFlight.startingAirportPlace.cityName,
                country: destinationFlight.startingAirportPlace.countryISO,
                code: destinationFlight.startingAirportPlace.airportCode,
            } : {};

            vm.data.place_selected_to = destinationFlight.returningAirportPlace ? {
                id: destinationFlight.returningAirportPlace.airportCode,
                displayText: destinationFlight.returningAirportPlace.cityName,
                displayDestinationHtml: destinationFlight.returningAirportPlace.cityFullName,
                displayHtml: destinationFlight.returningAirportPlace.cityName,
                country: destinationFlight.returningAirportPlace.countryISO,
                code: destinationFlight.returningAirportPlace.airportCode,
            } : {};

        }
        if (paramsData || storageData) {
            vm.data.checkIn = fn.getDate(vm.data.checkIn);
            vm.data.checkOut = fn.getDate(vm.data.checkOut);

            if ((+vm.data.checkIn <= +defaultDate)) {
                initialDefaultDate();
            }
        }
    }

    function initDatePicker() {
        let valid = isValidDate(vm.data.checkIn, vm.data.checkOut);
        if (!valid) {
            vm.data.checkOut = getInitialDate(vm.data.checkIn, config.bookerDefaultCheckOutDay);
        }

        onInitPicker(['calendar-checkIn-flight', 'calendar-checkOut-flight'], vm.data.checkIn, vm.data.checkOut, 'checkIn', 'checkOut')
    }


    function onInitPicker(element, startDate, endDate, checkIn, checkOut) {
        const plugins = ["LockPlugin"]

        if (vm.data.mode) {
            plugins.push("RangePlugin");
        }
        var css = !setting.rb ? [`${config.cloudCdn}/assets/css/dist/${config.siteName}/booker.css?id=${+(new Date())}`] : [];
        _datePicker = {
            element: document.getElementById(element[0]),
            css: css,
            zIndex: 10,
            grid: 2,
            calendars: 768 <= window.innerWidth ? 2 : 1,
            autoApply: true,
            readonly: true,
            lang: config.culture,
            date: startDate,
            format: localeDatePicker.format,
            plugins: plugins,
            LockPlugin: {
                minDate: defaultDate,
                minDays: 1,
            },
            RangePlugin: {
                tooltip: true,
                startDate: startDate,
                endDate: endDate,
                tooltipNumber(num) {
                    return num;
                },
                locale: {
                    one: lang.day,
                    other: lang.days,
                }
            },
            setup(picker) {
                picker.on("render", (e) => {
                    const nextButtons = picker.ui.container.querySelectorAll(".calendars .next-button");
                    const prevButtons = picker.ui.container.querySelectorAll(".calendars .previous-button");
                    if (nextButtons) {
                        nextButtons.forEach((button) => {
                            button.setAttribute('aria-label', 'Siguiente mes');
                        });
                    }
                    if (prevButtons) {
                        prevButtons.forEach((button) => {
                            button.setAttribute('aria-label', 'Anterior mes');
                        });
                    }
                });
                picker.on('select', (e) => {

                    const { start, end, date } = e.detail;

                    if (vm.data.mode) {
                        vm.data[checkIn] = start.toJSDate();
                        vm.data[checkOut] = end.toJSDate();
                    } else {
                        vm.data[checkIn] = date.toJSDate();
                    }
                });
            },
        };

        if (_picker) {
            _picker.destroy();
        }
        _picker = new easepick.create(_datePicker);
    }

    function getUserSelectionParams() {
        let params = fn.search();

        let data = {}

        /*let place = {
            code: "100409",
            displayHtml: "Mo?on Palace Cancun, Canc�n, Quintana Roo, M�xico",
            displayText: "Mo?on P&aacutelace Cancun, Canc�n, Quintana Roo, M�xico",
            distance: 0,
            id: 19458,
            isActive: true,
            items: [],
            locationInfo: {
                countryA2: "MX",
                countryISO: "MEX"
            },
            name: "Moon Palace Cancun",
            type: 14,
            uri: "moon-palace-cancun",
        };*/

        let placeOrigin = _placeOrigin;
        let placeDestination = _placeDestination;


        data.place_name = placeOrigin.DisplayText || "";
        data.place_name_to = placeDestination.DisplayText || "";

        data.place_selected = placeOrigin;
        data.place_selected_to = placeDestination;

        data.checkIn = params.startingFromDateTime || vm.data.checkIn;
        data.checkOut = params.returningFromDateTime || vm.data.checkOut;
        data.mode = (params.tripMode ? (params.mode === "1") : vm.data.mode);

        let pax = {
            adults: +(params[`adults`] || 1),
            children: []
        }

        let children = params[`agekids`];
        if (children) {
            let childrenSplit = children.split(",");

            for (var c = 0; c < childrenSplit.length; c++) {
                pax.children.push({
                    year: +(childrenSplit[c]) || 0
                })
            }
        }

        data.paxes = [pax];

        return data;
    }

    function initialDefaultDate() {
        vm.data.checkIn = getInitialDate(defaultDate);
        vm.data.checkOut = getInitialDate(defaultDate, config.bookerDefaultCheckInDay + config.bookerDefaultCheckOutDay);
    }

    function getInitialDate(date = fn.getDate(), value = config.bookerDefaultCheckInDay) {
        let dateNew = fn.getDate(fn.formatDate(date, setting.formatDate));
        dateNew.setDate(dateNew.getDate() + value)
        return dateNew;
    }


    function updateInputPaxes() {

        let adults = 0;
        let children = 0;
        let lengthPax = vm.data.paxes.length;
        for (let index = 0; index < lengthPax; index++) {
            const paxes = vm.data.paxes[index];
            adults += paxes.adults;
            children += paxes.children.length;
        }

        const roomTitle = lengthPax == 1 ? lang.room : lang.rooms;
        const adultsTitle = adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = children == 1 ? lang.child : lang.children;
        let childrenText = "";
        if (children > 0) {
            childrenText = `, ${children} ${childrenTitle}`;
        }
        vm.data.paxes_name = `${adults} ${adultsTitle}${childrenText}`;
        vm.data.paxes_people = adults + children;
        vm.data.capacityTotal = adults + children;
    }



    function MapPaxToUrl(pax) {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let infants = 0;
        let agekids = [];
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];
            let position = i + 1;

            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                kids += 1;
            }

        }
        paxesKeys[`adults`] = adults;
        paxesKeys[`kids`] = kids;
        paxesKeys[`agekids`] = agekids.join(",");


        return paxesKeys;
    }


    function isValidPax(pax, form) {
        let valid = true;
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];

            let childrens = room.children.length;
            for (let c = 0; c < childrens; c++) {
                let inputKid = form[`children_${i}_${c}`];
                if (inputKid.$invalid) {
                    valid = false;
                    break;
                }
            }

            if (!valid) {
                break;
            }
        }

        return valid;
    }


    function isValidDate(dateFrom, dateTo) {
        let valid = true;

        dateFrom.setHours(0, 0, 0, 0);

        if (+dateFrom > +dateTo) {
            valid = false;
        }
        return valid;
    }

    function onFocusElement(nameDiv) {
        setTimeout(() => {
            let element = nameDiv && document.getElementById(nameDiv);
            if (element) {
                element.focus();
            }
        }, 200)

    }

    function setValidation(prop) {
        if (prop == 'paxes') {
            vm.validation.paxes = isValidPax(vm.data.paxes, vm.form);
        }
    }

    function somePaxHasError() {
        if (vm.data && vm.data.paxes && vm.data.paxes.length) {
            for (let a = 0; a < vm.data.paxes.length; a++) {
                let pax = vm.data.paxes[a];
                if (pax && pax.children) {
                    if (pax.children.some(child => child.year === null && child.year === undefined)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function setSearchHistory(data) {
        let history = StorageService.get(setting.historyStorageParamFlight) || { from: [], to: [] };

        if (!history.from.some(elem => elem.id === data.place_selected.id)) {
            if (history.from.length >= maxhistorySize) {
                history.from = history.from.splice(0, maxhistorySize - 1);
            }
            history.from.unshift(data.place_selected);
        }

        if (!history.to.some(elem => elem.id === data.place_selected_to.id)) {
            if (history.to.length >= maxhistorySize) {
                history.to = history.to.splice(0, maxhistorySize - 1);
            }

            history.to.unshift(data.place_selected_to);
        }

        StorageService.set(setting.historyStorageParamFlight, history);
    }

    function getSearchHistory() {
        const localData = StorageService.get(setting.historyStorageParamFlight);
        if (localData) {
            vm.history = localData;
            vm.history.from = !vm.history.from.every(i => i.hasOwnProperty('displayDestinationHtml')) ? [] : vm.history.from;
            vm.history.to = !vm.history.to.every(i => i.hasOwnProperty('displayDestinationHtml')) ? [] : vm.history.to;
        }
    }

    function analyticsAlgolia(item, index, type) {
        internal.setDataArgolia(item, index, type);
    }
    function getAnalyticsTags() {
        var arrTags = [];
        if (fn.mobileAndTabletCheck()) {
            arrTags.push("web_mobile");
        } else {
            arrTags.push("web_desktop");
        }
        var pathName = _globalUtil.getFirstPathSegment();
        if (pathName == "hotel") {
            arrTags.push("detail");
        } else if (pathName == "hoteles" || pathName == "hotels") {
            arrTags.push("list");
        } else if (setting.page == 'landings') {
            arrTags.push("landings");
        } else {
            arrTags.push("home");
        }
        return arrTags.join(',');
    }
    function setRecentDestination(flight) {
        let registry = StorageService.get(setting.recentDestinationsFlight) || [];
        const exists = registry.findIndex(item => item.place_selected == flight.place_selected.id && item.place_selected_to == flight.place_selected_to.id);
        if (exists > -1) {
            const temp = registry[exists];
            registry.splice(exists, 1);
            registry.unshift(temp);
        } else {

            registry.unshift({
                checkIn: flight.checkIn,
                checkOut: flight.checkOut,
                paxes_name: flight.paxes_name,
                place_name: flight.place_selected.code,
                place_name_to: flight.place_selected_to.code,
                place_selected: flight.place_selected.id,
                place_selected_to: flight.place_selected_to.id,
                data: flight,
                origin: "V",
                IdG: flight.place_selected_to.code,
                icon: flight.mode ? config.cloudCdn + "/assets/img/Vuelo_redondo_icon.svg" : config.cloudCdn + "/assets/img/Vuelon_icon.svg",
                title: lang[flight.mode ? `flight_round_${setting.site.siteName}` : `flight_one_way_${setting.site.siteName}`],
                box: {
                    pax: flight.paxes,
                    checkIn: flight.checkIn,
                    checkOut: flight.checkOut
                },
                place: {
                    displayText: flight.place_selected_to.displayText
                }

            });
        }

        if (registry.length > setting.limitDestinations) {
            registry = registry.slice(0, setting.limitDestinations);
        }

        StorageService.set(setting.recentDestinationsFlight, registry);
    }
    init();
}
